import { formatAddress } from "localized-address-format";

export function getFormattedAddress(address) {
  return formatAddress({
    ...address,
    postalCountry: address.regionCode,
  }).join("\n");
}
